export default {
  meta: {
    title: '操作日志'
  },
};
